import { Link, useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { useState } from "react";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import StyledTextField from "../components/styled-text-field.compoment";
import config from "../config";
import logo from "../images/logo-with-caption.webp";
import { _post } from "../services/api.service";
import "../styles/login.css";
import { COLORS } from "../theme/theme.config";
import { getRecaptchaToken } from "../utils/recaptcha";

const PasswordResetForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const onEmailChange = (e: any) => {
    sessionStorage.setItem("USER_EMAIL", e.target.value);
    setEmail(e.target.value);
  };

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleEmailSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const token = await getRecaptchaToken(executeRecaptcha, "password_reset");
    if (!token) {
      return;
    }

    const payload = {
      email,
      recaptcha: token,
    };
    const userData = await _post("users/send-reset-password/", payload);
    if (userData) {
      navigate("/forgot-password");
    }
  };

  return (
    <div className="outer">
      <div className="middle">
        <div className="login_form">
          <form onSubmit={handleEmailSubmit} autoComplete="off">
            <div className="mb-4">
              <img src={logo} alt="Logo" style={{ height: "40px" }} />
            </div>
            <div className="content-container">
              <h1 className="login-heading">Password Reset</h1>
              <div className="login-description">
                <p>Enter your registered email address and we’ll send you an OTP to reset password.</p>
              </div>
            </div>
            <div className="mb-3">
              <StyledTextField
                fullWidth
                label="Email"
                type="email"
                variant="outlined"
                required
                autoFocus
                onChange={onEmailChange}
                inputProps={{ spellCheck: "false" }}
              />
            </div>
            {/* <div className="mb-4">
              <ReCAPTCHA
                sitekey="6LdAorgqAAAAAKEalYZOv_1al6H_KTiGzTAl4q4x"
                onChange={onReCaptchaChange}
              />
            </div> */}
            <div className="mt-3">
              <Button
                sx={{
                  backgroundColor: COLORS.green,
                  padding: "14px",
                  borderRadius: "0",
                  fontSize: "1rem",
                  color: "#09091c",
                  "&:hover": {
                    backgroundColor: COLORS.greenHover,
                  },
                  "&:disabled": {
                    backgroundColor: COLORS.greenDisabled,
                    color: "#09091c",
                  },
                }}
                variant="contained"
                fullWidth
                type="submit"
              >
                Get OTP
              </Button>
              <p className="sign_up mt-4">
                Back to
                <Link
                  style={{
                    marginLeft: "7px",
                    color: COLORS.green,
                    textDecoration: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                  to="/login"
                >
                  Login
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const PasswordReset = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.captchaKey}>
      <PasswordResetForm />
    </GoogleReCaptchaProvider>
  );
};

export default PasswordReset;
